/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Publish_AllInputs */

const cs_property_ai_publish_all = /** @type {(inputs: Property_Ai_Publish_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publikovat vše`)
};

const en_property_ai_publish_all = /** @type {(inputs: Property_Ai_Publish_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish all`)
};

/**
* | output |
* | --- |
* | "Publish all" |
*
* @param {Property_Ai_Publish_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_publish_all = /** @type {((inputs?: Property_Ai_Publish_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Publish_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_publish_all(inputs)
	return cs_property_ai_publish_all(inputs)
});